import { render, staticRenderFns } from "./db-modal-create-edit-form.vue?vue&type=template&id=08cf39cd&"
import script from "./db-modal-create-edit-form.vue?vue&type=script&lang=js&"
export * from "./db-modal-create-edit-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports